import { PropsWithChildren, useEffect } from "react";
import { BaseFormWithArrayFields } from "../core/BaseForm";
import useUserTrackingEvent from "./useUserTrackingEvent";

interface Props {
  eventName: string;
  form: BaseFormWithArrayFields;
  fieldsFilter?: (field: any) => boolean;
}

/**
 * Sends a user tracking event each time a field in the form that passes the filter changes.
 * @param {React.PropsWithChildren<Props>} props
 * @returns {JSX.Element}
 * @constructor
 */
function UserTrackingFormOnBlur(props: PropsWithChildren<Props>) {
  const send = useUserTrackingEvent(props.eventName);
  useEffect(() => {
    props.form.fields.forEach((f: any) => {
      if (props.fieldsFilter == null || props.fieldsFilter(f)) {
        const current = f.onBlur;
        f.onBlur = (e: InputEvent) => {
          if (current) {
            current(e);
          }
          send({
            boxFilled: f.name,
            label: f.metadata.displayName,
            value: f.metadata.type === "password" ? "*******" : f.$value,
          });
        };
      }
    });
  }, [props.form, props.fieldsFilter, send]);
  return props.children as JSX.Element;
}

export default UserTrackingFormOnBlur;
